export default (projectOrgStructure) => {
	if (!Array.isArray(projectOrgStructure)) return [];
	let admins = [];
	projectOrgStructure.forEach(({entityAdmins}) => (admins = [...admins, ...entityAdmins.map(({userId}) => userId)]));
	const uniqueAdmins = new Set(admins);
	return [...uniqueAdmins];
};
